import React from 'react'
import {Row, Col} from 'reactstrap';
//import {Link} from 'react-router-dom'
import moment from 'moment';
import {formatCurrency} from '../utils/Strings'

export default class RefundsResRow extends React.Component{
   
  render() {
    var r=this.props.refund;
    var strCourseDate=moment(r.startDateTime).format('YYYY-MM-DD')
    var strCourseTime=(
      <div>
        <span className="startTime">{moment(r.startDateTime).format('HH:mm')}</span>
        {'-'}
        <span className="finishTime">{moment(r.finishDateTime).format('HH:mm')}</span>
      </div>
    )    
    var strQty=''
    if (r.qtyNormal>0)
      strQty += r.qtyNormal + "N "
    if (r.qtyReduced>0)
      strQty += r.qtyReduced + "U"
    var strRefundDeduction=''
    if (r.refundDeduction>0){
      strRefundDeduction = formatCurrency(r.refundDeduction) 
      if (r.refundAgent>0)
        strRefundDeduction += ' /' + formatCurrency(r.refundAgent)
      strRefundDeduction = '(' + strRefundDeduction + ')'
    }
          
    return (      
      <Row className="align-items-center">
        <Col md="2" xs={{size: 2, order: 1}}>
        <div className="courseDate">{moment(r.refundDateTime).format('YYYY-MM-DD')}</div>
        <div className="courseDate">{moment(r.refundDateTime).format('HH:mm')}</div>
        </Col>
                
        
        <Col md="2" xs={{size: 4, order: 2}}>
        <div className="town">{r.startTown}</div>
        <div className="street">{r.startAddress}</div>
        </Col>
      
        <Col md="2" xs={{size: 4, order: 3}}>
        <div className="town">{r.finishTown}</div>
        <div className="street">{r.finishAddress}</div>
        </Col>                  
        
        <Col md="2" xs={{size: 2, order: 4}}>
        <div className="courseDate">{strCourseDate}</div>
        {strCourseTime}
        </Col> 
        
        <Col md="2" xs={{size: 3, order: 5}} className="order-xs-5 companyName">{r.companyName}</Col>                
        
        <Col md="1" xs={{size: 1, order: 7}} className="order-xs-7 amount">{strQty}</Col>   
      
        <Col md="1" xs={{size: 2, order: 8}} className="price right">{formatCurrency(r.refundPrice)}</Col>
        
        <Col md="2" xs={{size: 2, order: 9}} className="idRes">#{r.idRefund}</Col>        
        
        <Col md="4" xs={{size: 4, order: 6, push: 6, pull: 6}} className="order-xs-6 town">{r.lastName} {r.firstName}</Col>

        <Col md="4" xs={{size: 4, order: 6, push: 6, pull: 6}} className="order-xs-6 note">Rez.: #{r.idReservation} {moment(r.reservationDateTime).format('YYYY-MM-DD HH:mm')}</Col>
                
        <Col md="2" xs={{size: 2, order: 8}} className="refundAgent right">{strRefundDeduction}</Col>
        
        {/* {this.renderButtons(r)} */}
                      
      </Row>      
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/RefundsRow.js